/* Catalogue Governance Client barrel export */

import { CatalogueGovernanceClientMocked } from './catalogueGovernanceClientMocked';

export * from './catalogueGovernanceTypes';
export * from './ICatalogueGovernanceClient';

// No real backend exists for this domain yet — always use the in-code mocked client.
export const CatalogueGovernanceClient = new CatalogueGovernanceClientMocked();

export { CatalogueGovernanceClientMocked };
